export const AUTH_CLIENT_AUDIENCES = [
    'teetime-web',
    'teetime-admin',
    'billing-admin',
    'control-admin',
    'messaging-admin',
    'cmp-portal',
    'voicepro-web',
    'crm-admin',
    'scl-admin',
    'facilities-admin',
    'facilities-applicant',
    'yolo-admin',
    'yolo-shop',
];
export const REMEMBERED_DEVICE_DURATION_DAYS = 30;
const REMEMBERED_DEVICE_AUDIENCES = [
    'crm-admin',
    'facilities-admin',
    'facilities-applicant',
    'messaging-admin',
    'teetime-admin',
    'voicepro-web',
];
/**
 * Browser-safe login capabilities. The IDP repeats this policy before it
 * accepts a remembered-device request; this registry only controls what a
 * client may offer and label.
 */
export const AUTH_CLIENT_REMEMBERED_DEVICE_POLICIES = Object.fromEntries(REMEMBERED_DEVICE_AUDIENCES.map((audience) => [
    audience,
    { rememberedDeviceDurationDays: REMEMBERED_DEVICE_DURATION_DAYS },
]));
const AUTH_CLIENT_AUDIENCE_SET = new Set(AUTH_CLIENT_AUDIENCES);
export function isAuthClientAudience(value) {
    return AUTH_CLIENT_AUDIENCE_SET.has(value);
}
export function getRememberedDeviceDurationDays(audience) {
    const normalizedAudience = audience?.trim().toLowerCase();
    if (!normalizedAudience || !isAuthClientAudience(normalizedAudience)) {
        return undefined;
    }
    return AUTH_CLIENT_REMEMBERED_DEVICE_POLICIES[normalizedAudience]?.rememberedDeviceDurationDays;
}
//# sourceMappingURL=auth-client-audience.js.map